module.exports = __webpack_public_path__ + "img/2,w_1126.43010c38.jpg";